export enum PaymentMethodEnum {
  CashPayment = 1,
  Financed = 2
}
